/** @jsx jsx */
import { jsx } from "theme-ui";
import { useMemo } from "react";
import PropTypes from "prop-types";
import { get } from "sites-common/utils/lodash";

import { usePersist } from "gatsby-plugin-hfn-profile/globals";

import DynamicForm, {
  DynamicField,
} from "@heartfulnessinstitute/react-hfn-forms/dist/DynamicForm";
import { ActionButton, DefaultButton, Stack } from "office-ui-fabric-react";

const i18n = require("./json/i18n/strings.json");

const languages = Object.keys(i18n);

const defaultLang = "English";

export const useLang = () => {
  const [lang, setLang] = usePersist("lang_preference", defaultLang);

  const getLangString = useMemo(
    () => (str) => get(i18n[lang], str, get(i18n[defaultLang], str, str)),
    [lang]
  );

  return [getLangString, lang, setLang];
};

const LanguageSelector = () => {
  const [getLangString, lang, setLang] = useLang();
  return (
    <Stack verticalAlign="end" sx={{ maxWidth: "120px" }}>
      <DynamicField
        label={getLangString("strings.change_language")}
        type="select"
        value={lang}
        onChange={setLang}
        name="lang"
        options={languages}
        props={{ required: false }}
      />
    </Stack>
  );
};

const option_lists = require("./json/frro/options.json");

const transformFields = (formfields, getLangString) =>
  formfields.map((r) => ({
    ...r,
    label:
      "section_title" in r
        ? r.section_title.replace("TITLE", getLangString(r.label))
        : getLangString(r.label),
    ...("dropdown_options" in r
      ? { options: option_lists[r.dropdown_options] }
      : {}),
  }));

export const DynamicFormLang = ({
  formTitle,
  formFields,
  saveBtnText,
  discardBtnText,
  ...restParams
}) => {
  const [getLangString] = useLang();

  const formFieldsLang = useMemo(
    () => transformFields(formFields, getLangString),
    [formFields, getLangString]
  );
  const formTitleLang = formTitle ? getLangString(formTitle) : "";

  const buttons = {
    submitButton: (
      <DefaultButton
        type="submit"
        iconProps={{ iconName: "Save" }}
        text={getLangString(saveBtnText || "buttons.save")}
      />
    ),
    discardButton: (
      <ActionButton
        text={getLangString(discardBtnText || "buttons.discard")}
        iconProps={{ iconName: "Cancel" }}
      />
    ),
  };

  return (
    <DynamicForm
      formTitle={formTitleLang}
      formFields={formFieldsLang}
      buttons={buttons}
      {...restParams}
    />
  );
};

DynamicFormLang.propTypes = {
  formTitle: PropTypes.string,
  formFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  saveBtnText: PropTypes.string,
  discardBtnText: PropTypes.string,
};

DynamicFormLang.defaultProps = {
  formTitle: undefined,
  saveBtnText: undefined,
  discardBtnText: undefined,
};

export default LanguageSelector;
